import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '../components/Home/Home';
import ConnectionPopUp from '../components/profile/ConnectionPopUp/ConnectionPopUp';
import GoogleCookiesRediClose from '../components/profile/google_cookies_redi_close/google_cookies_redi_close';

import About from '../components/About/About';
import Profile from '../components/profile/profile/profile';
import MyProfile from '../components/profile/profile/myprofile/myprofile';
import ParametersFileGenerator from '../components/ParametersFileGenerator/ParametersFileGenerator';
import RisksFileGenerator from '../components/RisksFileGenerator/RisksFileGenerator';

import Users from '../components/Entities_/users/users';
import SignUP from '../components/profile/SignUP/SignUP';
import SignUP_Email_Sent_Success from '../components/profile/SignUP/SignUP_Email_Sent_Success/SignUP_Email_Sent_Success';
import ForgottenPassword from '../components/profile/ForgottenPassword/ForgottenPassword';
import ForgottenPasswordResetVerify from '../components/profile/ForgottenPassword/forgottenPassword_reset_verify/forgottenPassword_reset_verify';
import ActivateUser from '../components/profile/SignUP/activateUser/activateUser'
import UpdateUserMyProfileEmail from '../components/profile/profile/myprofile/updateUser_MyProfile_Email/updateUser_MyProfile_Email'
import UsersBroadcast from '../components/Entities_/users/users_boradcast';

import Tickets from '../components/Entities_/tickets/tickets';
import Messages from '../components/Entities_/messages/messages';
import Elements from '../components/Entities_/elements/elements';
import Parameters from '../components/Entities_/parameters/parameters';
import CSTR_Requirements from '../components/Entities_/CSTR_Requirements/CSTR_Requirements';
import Change_requests from '../components/Entities_/Change_requests/Change_requests';

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/Home" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/ConnectionPopUp" element={<ConnectionPopUp />} />
      <Route path="/google_cookies_redi_close" element={<GoogleCookiesRediClose />} />
      <Route path="/users/:page" element={<Users />} />
      <Route path="/signup" element={<SignUP />} />
      <Route path="/SignUP_Email_Sent_Success" element={<SignUP_Email_Sent_Success />} />
      <Route path="/ForgottenPassword" element={<ForgottenPassword />} />
      <Route path="/forgottenPassword_reset_verify/:token" element={<ForgottenPasswordResetVerify />} />
      <Route path="/ActivateUser/:token" element={<ActivateUser />} />
      <Route path="/updateUser_MyProfile_Email/:token" element={<UpdateUserMyProfileEmail />} />
      <Route path="/users_broadcast" element={<UsersBroadcast />} />
      
      <Route path="/profile" element={<Profile />} />
      <Route path="/myprofile" element={<MyProfile />} />
      <Route path="/tickets/:page" element={<Tickets />} />
      <Route path="/messages/:ref/:page" element={<Messages />} />
      <Route path="/elements/:page" element={<Elements />} />
      <Route path="/parameters/:page" element={<Parameters />} />
      <Route path="/CSTR_Requirements/:page" element={<CSTR_Requirements />} />
      <Route path="/Change_requests/:page" element={<Change_requests />} />
      <Route path="/Parameters_File_Generator" element={<ParametersFileGenerator />} />
      <Route path="/Risks_File_Generator" element={<RisksFileGenerator />} />
    </Routes>
  );
}
